import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './Section';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve si tengo ansiedad diagnosticada?',
    a: 'Sí. Aunque este sistema no reemplaza un tratamiento médico o psicológico, las técnicas de reprogramación y los rituales nocturnos son herramientas prácticas que complementan perfectamente cualquier terapia, ayudando específicamente a calmar el sistema nervioso en el momento de ir a dormir.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato. Apenas se confirma tu pago, recibís un mail con el enlace para descargar todos los módulos en formato PDF y los bonos (incluyendo el audio). Podés leerlos en tu celular, tablet, computadora o imprimirlos.'
  }, {
    q: '¿Qué lo diferencia de la melatonina o las infusiones?',
    a: "Los suplementos y tés actúan a nivel físico temporal, pero no resuelven el problema de raíz: la mente hiperactiva. Este sistema te enseña a 'apagar' el motor mental. Muchas mujeres descubren que al aplicar el método, ya no necesitan depender de ayudas externas."
  }, {
    q: '¿Tiene garantía real?',
    a: '100% real. Tenés 7 días para revisar todo el material y ponerlo a prueba. Si sentís que no es para vos, nos mandás un mail y te devolvemos el dinero completo el mismo día. Sin preguntas incómodas ni formularios largos.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'El Bono 1 (Ritual de 10 Minutos) está diseñado para que notes una diferencia en tu nivel de relajación esta misma noche. Para consolidar el hábito y dejar de despertarte a las 3am, el Plan de 21 días te guía paso a paso. La mayoría de nuestras alumnas reportan noches completas de sueño en la primera o segunda semana.'
  }];
  return <Section className="bg-bgLight py-24 px-4 sm:px-6 lg:px-8" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-headlineDark mb-12" data-id="element-58">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-59">
          {faqs.map((faq, i) => <div key={i} className="border border-cardBorder rounded-xl overflow-hidden bg-white" data-id="element-60">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left px-6 py-5 flex items-center justify-between hover:bg-bgLight transition-colors focus:outline-none" aria-expanded={openIndex === i} data-id="element-61">
                <span className="font-semibold text-headlineDark pr-8" data-id="element-62">
                  {faq.q}
                </span>
                <span className={`text-ctaFrom transform transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-63">
                  ▼
                </span>
              </button>

              <AnimatePresence data-id="element-64">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-65">
                    <div className="px-6 py-5 bg-white text-bodyOnLight border-t border-cardBorder leading-relaxed" data-id="element-66">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}